import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IFormStore } from '../interface';
import { CommonReportingForEntityModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: CommonReportingForEntityModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class CommonReportingForEntityStore extends ComponentStore<State> implements IFormStore {
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<CommonReportingForEntityModel>((_, data) => {
    return { state: 'valid', data: CommonReportingForEntityModel.fromJson(data) };
  });

  constructor() {
    super(initialState);
  }
}
